import { Pipe, PipeTransform } from '@angular/core';

const GRADE_LETTERS = ['A', 'B', 'C', 'D', 'E'] as const;

@Pipe({
  name: 'gradeLetter',
  pure: true,
})
export class GradeLetterPipe implements PipeTransform {
  transform(grade: number | null | undefined): string {
    if (grade === null || grade === undefined) return '';
    const index = grade - 1;
    return GRADE_LETTERS[index] ?? '';
  }
}
